<template>
  <div>
    <!-- page-add-block-serg -->
    <div class="page-add-block-serg">
      <section
        class="
                  add_new_head add_new_head-h
                  white--body
                  tx--bege
                  relative
                  cover
                  m_bg_blue-serg
                "
      >
        <div class="popup_close close-animate">
          <a @click="$router.go(-1)">
            <CloseSvg />
          </a>
        </div>
        <a class="no_mobile link_goback cursor-p" @click="$router.go(-1)">
          חזרה
          <ArrowBackSvg />
        </a>
        <div class="inner_width flex flex--column center">
          <h1 class="title">
            <span class="bold block">הזמנת בלוק לחדר ניתוח</span>
            {{ activeDoctor.name }}
          </h1>
        </div>
      </section>
      <section class="page-edit-padd bg--white">
        <div class="subtitle center">
          יש לבחור חלון זמנים פנוי ולעדכן את משך הבלוק הדרוש במידה ולא אותר זמן
          מתאים,
          <span class="surg-add-block-subtitle">
            ניתן לשלוח בקשה כללית למוקד חדר ניתוח
          </span>
        </div>
        <ValidationObserver ref="addNewBlock" class="max--680 block">
          <form
            @submit.prevent="saveBlock"
            v-promise-btn="{ action: 'submit' }"
            name="addNewBlock"
            autocomplete="off"
          >
            <div class="hold-inp-block-serg flex flex--top">
              <div class="filter_select">
                <input
                  v-if="blocksTypes && blocksTypes.length === 1"
                  :value="selectedType.name"
                  disabled
                />
                <select2 v-else v-model="selected_type">
                  <option value="">יש לבחור סוג בלוק</option>
                  <option
                    v-for="block in blocksTypes"
                    :key="block.id"
                    :value="block.id"
                  >
                    {{ block.name }}
                  </option>
                </select2>
              </div>
              <div
                @click="toggleVueCal"
                class="input-block-serg flex flex--content--center"
              >
                <span class="no_mobile tx--blue2">בחירת תאריך</span>
                <img src="/assets/img/svg/ic-date.svg" />
                <input
                  type="text"
                  class="datepicker"
                  :class="{ pointer: selected_type }"
                  v-model="selected_date"
                  placeholder="תאריך"
                  :disabled="!selected_type"
                />
              </div>
              <div
                class="calandr_main calandr_main_add_app pop-date flex flex--column only-in-app"
                v-show="showVueCal"
              >
                <div class="glob-date-open bg--white">
                  <a
                    @click="toggleVueCal"
                    class="restart-date flex flex--center cursor-p"
                  >
                    <img src="/assets/img/svg/close-sm-blue.svg" />
                  </a>
                  <vue-cal
                    xsmall
                    locale="he"
                    :time="false"
                    :min-date="minDate"
                    :startWeekOnSunday="true"
                    hide-view-selector
                    active-view="month"
                    :disable-views="['years', 'week', 'day']"
                    @cell-focus="onCellClick"
                    class="vuecal--green-theme vuecal--rounded-theme mini-month"
                    :events="calendarEvents"
                    events-count-on-year-view
                    @view-change="changeView"
                    :hide-weekdays="[6]"
                  >
                    <template v-slot:weekday-heading="{ heading }">
                      <span v-if="heading.label == 'ראשון'">א׳</span>
                      <span v-if="heading.label == 'שני'">ב׳</span>
                      <span v-if="heading.label == 'שלישי'">ג׳</span>
                      <span v-if="heading.label == 'רביעי'">ד׳</span>
                      <span v-if="heading.label == 'חמישי'">ה׳</span>
                      <span v-if="heading.label == 'שישי'">ו׳</span>
                      <span v-if="heading.label == 'שבת'">ש׳</span>
                    </template>
                    <template v-slot:events-count="{ events }">
                      <span v-if="false"> {{ countDot(events) }} </span>
                    </template>
                  </vue-cal>
                </div>
              </div>
            </div>
            <div
              v-show="Object.keys(availRoomsMap).length"
              class="switch-container"
            >
              <label class="switch">
                <input type="checkbox" v-model="showStandby" />
                <span class="slider"></span>
              </label>
              <span>
                הצג כולל בלוקים ב-
                <span style="font-size: 22px;padding-right: 0;">STANDBY</span>
              </span>
            </div>
            <div
              class="choose-room choose-room-row"
              :class="activeRow[date] ? 'active' : ''"
              v-for="(rooms, date) in availRoomsMap"
              :key="date + 1"
              v-show="isShowDate(rooms)"
            >
              <div class="text relative" @click="showRow(date)">
                {{ $moment(new Date(date)).format("DD/MM/YYYY") }}
                <div class="plus desk-hide"></div>
                <div class="circ-arrow flex flex--column no_mobile">
                  <img src="assets/img/svg/arrow_down_blue.svg" />
                </div>
              </div>

              <div class="all-rooms flex flex--start" v-show="activeRow[date]">
                <div
                  class="room-choise bg--bege ease"
                  @click="selectRoom(room, index)"
                  :class="{
                    active:
                      selected_room &&
                      selected_room.room == room.room &&
                      selected_room.start == room.start &&
                      selected_room.end == room.end,
                    standby: room.isIncludeSlotsInsideBlocks
                  }"
                  v-for="(room, index) in rooms"
                  :key="room.room + '-' + index"
                  v-show="
                    showStandby ||
                      (!showStandby && !room.isIncludeSlotsInsideBlocks)
                  "
                >
                  <span
                    v-show="room.isIncludeSlotsInsideBlocks"
                    class="standby-label"
                  >
                    STANDBY
                  </span>
                  <b>{{ room.room_name.name }}</b>
                  {{ $moment(room.end).format("HH:mm") }} -
                  {{ $moment(room.start).format("HH:mm") }}
                </div>
              </div>
            </div>

            <div class="flex flex--content--center">
              <vue-loaders-ball-clip-rotate
                v-show="
                  selected_type &&
                    (!availRoomsMap || !Object.keys(availRoomsMap).length)
                "
                color="black"
                scale="2"
                style="margin: 40px 0;"
              ></vue-loaders-ball-clip-rotate>
            </div>
            <!-- end all-rooms-->
            <div
              class="flex"
              :style="isMiniMobile ? 'padding: 0 6px;' : ''"
              v-show="availRoomsMap && Object.keys(availRoomsMap).length"
            >
              <a
                v-show="isMoreDates"
                class="link_blue show-more-rm center"
                href="javascript:void(0);"
                @click="showMoreRoomsDates"
              >
                הצג תאריכים <br v-show="isMiniMobile" />
                נוספים
              </a>
              <a
                class="link_blue show-more-rm center"
                href="javascript:void(0);"
                @click="surgBlockRequest"
              >
                הגשת בקשה <br v-show="isMiniMobile" />
                לתאריך אחר
              </a>
            </div>
            <!-- end all-rooms-->

            <div class="choose-room-time border-top" v-if="selected_room">
              <div v-show="!isRequestBlock" class="text center let-1 mb-15">
                ניתן לערוך את שעת ההתחלה והסיום מתוך חלון הזמנים שנבחר
              </div>
              <div class="edit-hours-start flex">
                <div v-if="isRequestBlock" class="page-edit-row w-100">
                  <label>תאריך מבוקש</label>
                  <div class="form_input surg-time surg-block-date">
                    <validation-provider
                      name="date"
                      rules="required|valid_date|date_before_today"
                      v-slot="{ errors }"
                    >
                      <input
                        @focus="$event.target.select()"
                        type="text"
                        name="date"
                        placeholder="dd/mm/yyyy"
                        v-mask="['##/##/####']"
                        v-model="requestedDate"
                      />
                      <span class="error-message">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                </div>
                <div class="page-edit-row">
                  <label>שעת התחלה</label>
                  <div class="form_input surg-time">
                    <validation-provider
                      name="start_time"
                      :rules="startTimeRules"
                      :events="['blur']"
                      v-slot="{ errors }"
                    >
                      <cleave
                        :value="custom_start_time"
                        :options="options"
                        @input="onCleave('custom_start_time', $event)"
                        @focus.native="e => e.target.select()"
                      ></cleave>
                      <span class="error-message">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                </div>
                <div class="page-edit-row">
                  <label>שעת סיום</label>
                  <div class="form_input surg-time">
                    <validation-provider
                      name="end_time"
                      :rules="endTimeRules"
                      :events="['blur']"
                      v-slot="{ errors }"
                    >
                      <cleave
                        :value="custom_end_time"
                        :options="options"
                        @input="onCleave('custom_end_time', $event)"
                        @focus.native="e => e.target.select()"
                      ></cleave>
                      <span class="error-message">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                </div>
                <div class="page-edit-row w-100">
                  <label>הערות</label>
                  <div class="form_input surg-time">
                    <textarea
                      placeholder="חדר מבוקש, עזרים וכלים מיוחדים וכו..."
                      v-model="notes"
                    ></textarea>
                  </div>
                </div>
                <div
                  v-show="isRequestBlock"
                  class="text center let-1 mb-15 add-surg-blok-note"
                >
                  *אישור הבלוק מותנה בזמינות חדר הניתוח ואינו סופי עד לאישור
                  הבקשה ע"י מוקד חדר ניתוח.
                </div>
              </div>
            </div>
            <!-- end choose-room-time -->
            <button
              class="bt_blue w-100 mt-40 desk-w-100"
              type="submit"
              :class="{ bt_disable: !validBlock }"
            >
              שמירה
            </button>
          </form>
        </ValidationObserver>
      </section>
      <!-- end page-add-block-serg -->
    </div>
  </div>
</template>

<script>
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/he.js";
import "vue-cal/dist/vuecal.css";
import CloseSvg from "../../../assets/img/svg/close.svg";
import ConfirmSurgBlock from "@/components/Popups/ConfirmSurgBlock";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Error from "@/components/Popups/Error";
import ArrowBackSvg from "../../../assets/img/svg/arrow_r.svg";
// import VueTimepicker from "vue2-timepicker";
import Cleave from "vue-cleave-component";

export default {
  name: "SurgAddBlock",
  data() {
    return {
      options: {
        time: true,
        timePattern: ["h", "m"]
      },
      showVueCal: false,
      allExistBlocks: [],
      activeDate: null,
      blocksTypes: [],
      selected_type: "",
      date: "",
      selected_date: "",
      allBlocks: [],
      blocks_map: [],
      blocks_map_calendar: [],
      selected_room: null,
      custom_start_time: "",
      custom_end_time: "",
      date_from: this.$moment(),
      date_to: this.$moment(),
      activeRow: {},
      start_time_static: "",
      end_time_static: "",
      isMoreDates: true,
      daysNumberForSurgSlot: 7,
      isRequestBlock: false,
      requestedDate: "",
      notes: "",
      mapCalcDateFrom: "",
      mapCalcDateTo: "",
      isMiniMobile: false,
      showStandby: true
    };
  },
  watch: {
    async selected_type(value, oldvalue) {
      if (value != oldvalue) {
        this.selected_date = "";
        let date_from = this.$moment(new Date()).format("YYYY-MM-DD");
        let date_to = this.$moment(new Date())
          .add("2", "month")
          .format("YYYY-MM-DD");

        this.activeRow = {};

        if (!this.activeDoctor) {
          const activeUser = JSON.parse(localStorage.getItem("activeDoctor"));
          if (activeUser && activeUser.id) await this.SET_DOCTOR(activeUser.id);
        }
        const activeUser =
          this.activeDoctor ?? JSON.parse(localStorage.getItem("activeDoctor"));

        if (activeUser && activeUser.id) {
          this.$API
            .getBlockMaps(activeUser.id, activeUser.id, date_from, date_to)
            .then(res => {
              // check if set minimum events for calculation
              let dateToCalcMap = this.$moment()
                .add("1", "month")
                .format("YYYY-MM-DD");
              if (
                this.$moment(dateToCalcMap, "YYYY-MM-DD").isBefore(
                  this.$moment(date_to)
                )
              ) {
                this.mapCalcDateTo = dateToCalcMap;
              }
              this.blocks_map = [...res];
              this.blocks_map_calendar = JSON.parse(JSON.stringify(res));
            });
        }
      }
    }
  },
  mounted() {
    this.isMiniMobile = window.innerWidth < 480;

    // get doctor blocks types
    this.$API.getAllDoctorBlockType(this.activeDoctor.id).then(res => {
      this.blocksTypes = res.data.data;
      if (this.blocksTypes && this.blocksTypes.length == 1) {
        this.selected_type = this.blocksTypes[0].id;
      }
    });
  },
  computed: {
    ...mapGetters(["activeDoctor", "activeUser", "doctors", "allRooms"]),
    endTimeRules() {
      const rules = {
        required: true,
        timeFormat: [this.custom_start_time],
        interval: [this.custom_start_time],
        isBigger: [this.custom_start_time],
        duration: [this.custom_start_time]
      };
      if (!this.isRequestBlock) rules.max = [this.end_time_static, this.date];
      return rules;
    },
    startTimeRules() {
      const rules = {
        required: true,
        timeFormat: [this.custom_end_time],
        interval: [this.custom_end_time],
        isSmallest: [this.custom_end_time]
      };
      if (!this.isRequestBlock) rules.min = this.start_time_static;
      return rules;
    },
    requestRoom() {
      if (!this.validRooms) return null;
      return { room: "surgery_10", room_name: this.validRooms["surgery_10"] };
    },
    validBlock() {
      if (this.selected_room && this.selectedType) {
        return true;
      }
      return false;
    },
    selectedType() {
      if (!this.blocksTypes || !this.blocksTypes.length) return;
      let blockType = "";
      blockType = this.blocksTypes.find(b => b.id == this.selected_type);

      return blockType || "";
    },
    calendarEvents() {
      let events = [];

      let map = {};
      let block_type =
        this.selectedType !== undefined ? this.selectedType.type : false;

      if (!block_type) return [];
      for (const index in this.blocks_map_calendar) {
        let date = this.$moment(
          new Date(this.blocks_map_calendar[index].start_datetime)
        ).format("YYYY-MM-DD");
        let room = this.blocks_map_calendar[index].room.split("_");
        let room_type = room[0];

        if (map[date] === undefined) {
          map[date] = [];
        }
        if (room_type == block_type) {
          map[date].push(this.blocks_map_calendar[index]);
        }
      }
      let finalTime = this.getFilterEvents(map);
      for (const key in finalTime) {
        if (key) {
          events.push({
            start: new Date(key),
            end: new Date(key)
          });
        }
      }

      return events;
    },
    validRooms() {
      if (this.selectedType) {
        let block_type =
          this.selectedType !== undefined ? this.selectedType.type : false;
        let rooms = {};
        let all_rooms = this.allRooms;
        for (const key in all_rooms) {
          if (key.indexOf(block_type) > -1) {
            rooms[key] = all_rooms[key];
          }
        }
        return rooms;
      }

      return [];
    },
    availRoomsMap() {
      let map = this.calculatedMap;
      let calcMap = this.getFilterEvents(map);
      let finalTime = {};
      if (this.selected_date) {
        for (const key in calcMap) {
          const sd = this.$moment(this.selected_date);
          const keyd = this.$moment(key, "YYYY-MM-DD");
          if (keyd.isAfter(sd) || keyd.isSame(sd)) {
            finalTime[key] = calcMap[key];
          }
        }
      } else {
        finalTime = calcMap;
      }
      let j = 0;
      for (const key in finalTime) {
        this.setActiveDatesObject(key, j);
        j++;
      }
      return finalTime;
    },
    calculatedMap() {
      let map = {};
      let block_type =
        this.selectedType !== undefined ? this.selectedType.type : false;
      const full_map = this.blocks_map;

      if (block_type) {
        for (const index in full_map) {
          let date = this.$moment(
            new Date(full_map[index].start_datetime)
          ).format("YYYY-MM-DD");
          // check if block inside a limits dates
          if (this.mapCalcDateTo) {
            let limitDate = this.$moment(this.mapCalcDateTo, "YYYY-MM-DD");
            if (limitDate.isBefore(this.$moment(date, "YYYY-MM-DD"))) continue;
          }
          if (this.mapCalcDateFrom) {
            let limitDate = this.$moment(this.mapCalcDateFrom, "YYYY-MM-DD");
            if (limitDate.isAfter(this.$moment(date, "YYYY-MM-DD"))) continue;
          }

          let room = full_map[index].room.split("_");
          let room_type = room[0];

          if (map[date] === undefined) {
            map[date] = [];
          }
          if (room_type == block_type) {
            map[date].push(full_map[index]);
          }
        }
      }
      return map;
    },
    minDate() {
      return new Date();
    }
  },
  methods: {
    ...mapMutations(["SET_PASSPORT"]),
    ...mapActions(["SET_SURGERY_PATIENT", "SET_DOCTOR"]),
    onCleave(type, ev) {
      if (ev) {
        this[type] = ev.substring(0, 2) + ":" + ev.substring(2, ev.length);
      } else {
        this[type] = ev;
      }
    },
    onActiveDate(date) {
      if (this.activeDate === date) this.activeDate = null;
      else this.activeDate = date;
    },
    setActiveDatesObject(date, i) {
      const bool = i < 2 ? true : false;
      this.$set(this.activeRow, date, bool);
    },
    showRow(date) {
      this.activeRow[date] = !this.activeRow[date];
    },
    showMoreRoomsDates() {
      if (!this.isMoreDates) return;
      this.isMoreDates = false;
      this.mapCalcDateTo = "";
    },
    selectRoom(room, date) {
      this.isRequestBlock = false;
      if (
        this.selected_room &&
        room.room === this.selected_room.room &&
        room.start === this.selected_room.start &&
        room.end === this.selected_room.end
      ) {
        this.selected_room = null;
        this.custom_start_time = null;
        this.custom_end_time = null;
        this.start_time_static = null;
        this.end_time_static = null;
      } else {
        this.selected_room = room;
        this.custom_start_time = this.$moment(room.start).format("HH:mm");
        this.start_time_static = this.$moment(room.start).format("HH:mm");
        this.custom_end_time = null;
        this.end_time_static = this.$moment(room.end).format("HH:mm");
        setTimeout(() => {
          window.scrollTo({
            top: document.body.scrollHeight,
            left: 0,
            behavior: "smooth"
          });
        }, 200);
      }
    },
    // checkRooms(roomsArray) {
    //   let rooms = [];
    //   let valid_rooms = this.validRooms;
    //   for (const key in valid_rooms) {
    //     let find = roomsArray.filter(room => room.room == key);
    //     if (find.length == 0) {
    //       rooms.push({
    //         room: key,
    //         room_name: valid_rooms[key]
    //       });
    //     }
    //   }
    //   return rooms;
    // },
    async saveBlock() {
      const validate = await this.$refs.addNewBlock.validate();
      if (!validate) return;
      return new Promise((resolve, reject) => {
        let date_start, date_end;
        if (this.isRequestBlock) {
          const formattedDate = this.$moment(
            this.requestedDate,
            "DD/MM/YYYY"
          ).format("YYYY-MM-DD");
          date_start = `${formattedDate}T${this.custom_start_time}:00`;
          date_end = `${formattedDate}T${this.custom_end_time}:00`;
        } else {
          let custom_start_arr = this.custom_start_time.split(":");
          let custom_end_arr = this.custom_end_time.split(":");
          date_start = this.$moment(new Date(this.selected_room.start))
            .hours(custom_start_arr[0])
            .minutes(custom_start_arr[1])
            .format("YYYY-MM-DDTHH:mm:00");
          date_end = this.$moment(new Date(this.selected_room.end))
            .hours(custom_end_arr[0])
            .minutes(custom_end_arr[1])
            .format("YYYY-MM-DDTHH:mm:00");
        }

        let new_block = {
          type_id: this.selectedType.id,
          room: this.selected_room.room,
          start: date_start,
          end: date_end,
          title: this.selectedType.name
        };
        if (this.notes)
          new_block.notes = "בקשה לבלוק מהאפליקציה - " + this.notes;
        else new_block.notes = "בקשה לבלוק מהאפליקציה";

        resolve(true);
        this.$API
          .saveNewBlock(new_block)
          .then(res => {
            if (res.status == "OK") {
              this.$modal.show(ConfirmSurgBlock, {
                date: date_start,
                isRequestBlock: this.isRequestBlock
              });
            }
            resolve(true);
          })
          .catch(e => {
            this.$modal.show(Error);
          });

        resolve(true);
      });
    },
    toggleVueCal() {
      this.showVueCal = !this.showVueCal;
    },
    onCellClick(ev) {
      this.date = this.$moment(ev).format("DD/MM/YYYY");
      this.selected_date = this.$moment(ev).format("YYYY-MM-DD");
      this.date_from = ev;
      this.selected_room = null;
      this.mapCalcDateFrom = this.selected_date;
      if (
        this.mapCalcDateTo &&
        this.$moment(this.selected_date, "YYYY-MM-DD").isSameOrAfter(
          this.$moment(this.mapCalcDateTo, "YYYY-MM-DD")
        )
      ) {
        this.mapCalcDateTo = "";
        this.isMoreDates = false;
      }
      this.showVueCal = false;
    },
    changeView(ev) {
      // let date_from = ev.startDate;
      // let date_to = this.$moment(ev.startDate).add("1", "month");
      // date_from = date_from.format("YYYY-MM-DD");
      // date_to = date_to.format("YYYY-MM-DD");
      // this.$API
      //   .getBlockMaps(
      //     this.activeDoctor.id,
      //     this.activeDoctor.id,
      //     date_from,
      //     date_to
      //   )
      //   .then(res => {
      //     this.blocks_map_calendar = [...res];
      //   });
    },
    getEmptyRooms(map) {
      // get rooms without blocks
      let roomsCountEv = [0, 0, 0, 0, 0, 0, 0, 0, 0];
      let availableRooms = {};
      for (const key in map) {
        map[key].forEach(ev => {
          const index = parseInt(ev.room.slice(-1)) - 1;
          roomsCountEv[index]++;
        });
        let tmp = [];
        roomsCountEv.forEach((roomCount, i) => {
          const roomNum = i + 1;
          if (roomCount == 0) tmp.push("surgery_" + roomNum);
        });
        availableRooms[key] = tmp;
        roomsCountEv = [0, 0, 0, 0, 0, 0, 0, 0, 0];
      }
      return availableRooms;
    },
    mergeSlots(slots) {
      // Define a function to merge overlapping slots
      const merged = [];
      let currentSlot = null;

      slots.sort((a, b) => this.$moment(a.start).diff(this.$moment(b.start)));

      for (const slot of slots) {
        if (currentSlot === null) {
          currentSlot = { ...slot };
        } else if (this.$moment(currentSlot.end).isSameOrAfter(slot.start)) {
          currentSlot.end = this.$moment
            .max(this.$moment(currentSlot.end), this.$moment(slot.end))
            .toISOString();
        } else {
          merged.push({ ...currentSlot });
          currentSlot = { ...slot };
        }
      }

      if (currentSlot) merged.push(currentSlot);

      return merged;
    },
    groupSlotsByRoom(slots) {
      // Create a map to group slots by room
      const roomSlots = new Map();

      // Iterate through the slots and group them by room
      slots.forEach(slot => {
        const roomName = slot.room;
        if (!roomSlots.has(roomName)) {
          roomSlots.set(roomName, []);
        }
        roomSlots.get(roomName).push(slot);
      });

      // Process each room's slots
      const mergedSlots = [];

      for (const [roomName, roomSlotsList] of roomSlots.entries()) {
        const mergedRoomSlots = this.mergeSlots(roomSlotsList);

        // Remove slots that are less than 2 hours long
        const filteredRoomSlots = mergedRoomSlots.filter(
          slot =>
            this.$moment(slot.end).diff(this.$moment(slot.start), "hours") >= 2
        );

        mergedSlots.push(...filteredRoomSlots);
      }

      return mergedSlots;
    },
    getSurgeriesArrayType(surgeries) {
      const arr = Array.isArray(surgeries)
        ? surgeries
        : Object.values(surgeries);
      return arr.sort((a, b) => {
        const startTimeA = this.$moment(a.start);
        const startTimeB = this.$moment(b.start);

        return startTimeA.isBefore(startTimeB) ? -1 : 1;
      });
    },
    calcAvailableHoursInsideBlocks(room, nextRoom, isIncludeSlotsInsideBlocks) {
      room.surgeries = this.getSurgeriesArrayType(room.surgeries);

      // Some of doctor type can't be calculate - hmc request
      if (room.doctor_type == "vip") return [];

      const minSlotDuration = this.$moment.duration(2, "hours");
      const availableSlots = [];

      // Calculate available time slots
      const roomStartTime = this.$moment(
        room.start_datetime,
        "YYYY-MM-DDTHH:mm"
      );
      const roomEndTime = this.$moment(room.end_datetime, "YYYY-MM-DDTHH:mm");
      // Room overlaps with the day's time range
      room.surgeries.sort((a, b) => {
        const aStart = this.$moment(a.start, "YYYY-MM-DD HH:mm:ss");
        const bStart = this.$moment(b.start, "YYYY-MM-DD HH:mm:ss");
        return aStart.isBefore(bStart) ? -1 : 1;
      });
      const roomOccupiedSlots = room.surgeries.map(surgery => ({
        start: this.$moment(surgery.start, "YYYY-MM-DD HH:mm:ss"),
        end: this.$moment(surgery.end, "YYYY-MM-DD HH:mm:ss")
      }));

      // Calculate available slots within this room
      let currentSlotStart = roomStartTime;
      for (const occupiedSlot of roomOccupiedSlots) {
        const gapDuration = occupiedSlot.start.diff(currentSlotStart);
        if (gapDuration >= minSlotDuration) {
          availableSlots.push({
            start: currentSlotStart,
            end: occupiedSlot.start,
            room: room.room,
            room_name: this.validRooms[room.room]
          });
        }
        currentSlotStart = occupiedSlot.end;
      }

      // Check if there is an available slot after the last occupied slot in the room
      // if (roomEndTime.diff(currentSlotStart) >= minSlotDuration) {
      if (!roomEndTime.isSame(currentSlotStart)) {
        let slotEnd = roomEndTime;

        if (nextRoom) {
          nextRoom.surgeries = nextRoom.surgeries
            ? this.getSurgeriesArrayType(nextRoom.surgeries)
            : null;

          const nextRoomStartTime = this.$moment(nextRoom.start_datetime);

          // check if a end of the slot need to be next room start
          if (nextRoomStartTime.isAfter(roomEndTime)) {
            slotEnd = nextRoomStartTime;
          }

          // check if a end of the slot need to be next room first surgery start
          if (nextRoom.surgeries && nextRoom.surgeries.length) {
            const firstSurgeryStartTime = this.$moment(
              nextRoom.surgeries[0].start
            );
            const isTimeSlotAvailable = firstSurgeryStartTime.isAfter(
              nextRoomStartTime
            );
            if (isTimeSlotAvailable) slotEnd = firstSurgeryStartTime;
          }
        }

        availableSlots.push({
          start: currentSlotStart,
          end: slotEnd,
          room: room.room,
          room_name: this.validRooms[room.room],
          isIncludeSlotsInsideBlocks
        });
      }
      return availableSlots;
    },
    calcAvailableHoursBetweenBlocks(map) {
      let roomsMap = {};

      for (const date in map) {
        if (!roomsMap[date]) roomsMap[date] = [];
        const isIncludeSlotsInsideBlocks = this.includeSlotsInsideBlocks(date);
        // object of rooms key with array of blocks for calculation
        let blocksByRoom = map[date].reduce((obj, d) => {
          // hmc request - not include specific rooms
          if (
            d.room !== "surgery_10" &&
            d.room !== "surgery_11" &&
            d.room !== "surgery_12" &&
            d.room !== "surgery_13"
          ) {
            if (!obj[d.room]) obj[d.room] = [];
            obj[d.room].push({
              start_datetime: this.$moment(
                d.start_datetime,
                "YYYY-MM-DDTHH:mm"
              ).format("YYYY-MM-DDTHH:mm"),
              // .add(3, "h")
              end_datetime: this.$moment(
                d.end_datetime,
                "YYYY-MM-DDTHH:mm:ss"
              ).format("YYYY-MM-DDTHH:mm"),
              // .add(3, "h")
              availableSlots: d
            });
          }

          return obj;
        }, {});
        for (const room in blocksByRoom) {
          const today = this.$moment(new Date()).format("YYYY-MM-DD");
          const numDay = this.$moment(date).weekday();
          if (numDay == 6 || today == date) continue;
          let startHour = this.$moment(date + "T07:00", "YYYY-MM-DDTHH:mm");
          let endHour;
          if (numDay == 5) {
            // Friday end
            endHour = this.$moment(date + "T15:00", "YYYY-MM-DDTHH:mm");
          } else {
            endHour = this.$moment(date + "T23:00", "YYYY-MM-DDTHH:mm");
          }
          for (let i = 0; i < blocksByRoom[room].length; i++) {
            // add available slots from existed room
            const nextRoom = blocksByRoom[room][i + 1]
              ? blocksByRoom[room][i + 1].availableSlots
              : null;
            blocksByRoom[room][
              i
            ].availableSlots = this.calcAvailableHoursInsideBlocks(
              blocksByRoom[room][i].availableSlots,
              nextRoom,
              isIncludeSlotsInsideBlocks
            );

            const bStart = this.$moment(
              blocksByRoom[room][i].start_datetime,
              "YYYY-MM-DDTHH:mm"
            );
            const bEnd = this.$moment(
              blocksByRoom[room][i].end_datetime,
              "YYYY-MM-DDTHH:mm"
            );
            if (!startHour.isSame(bStart) && startHour.isBefore(bStart)) {
              let duration = this.$moment.duration(bStart.diff(startHour));
              let hours = duration.asHours();
              if (hours >= 2) {
                roomsMap[date].push({
                  room: room,
                  room_name: this.validRooms[room],
                  start: startHour,
                  end: bStart
                });
                startHour = bEnd;
              } else {
                startHour = bEnd;
              }
            } else if (startHour.isSame(bStart) || startHour.isAfter(bStart)) {
              startHour = bEnd;
            }

            if (
              i === blocksByRoom[room].length - 1 &&
              !endHour.isSame(bStart)
            ) {
              const availableSlots = blocksByRoom[room][i].availableSlots;
              const lastIndex = availableSlots.length - 1;
              const minSlotDuration = this.$moment.duration(2, "hours");
              if (
                isIncludeSlotsInsideBlocks &&
                availableSlots[lastIndex] &&
                availableSlots[lastIndex].end.isSame(bEnd) &&
                bEnd.isBefore(endHour) &&
                endHour.diff(availableSlots[lastIndex].start) >= minSlotDuration
              ) {
                roomsMap[date].push({
                  room: room,
                  room_name: this.validRooms[room],
                  start: availableSlots[lastIndex].start,
                  end: endHour,
                  isIncludeSlotsInsideBlocks
                });
                blocksByRoom[room][i].availableSlots.splice(lastIndex, 1);
              } else {
                let duration = this.$moment.duration(endHour.diff(bEnd));
                let hours = duration.asHours();
                if (hours >= 2) {
                  roomsMap[date].push({
                    room: room,
                    room_name: this.validRooms[room],
                    start: bEnd,
                    end: endHour
                  });
                }
              }
            }
            if (isIncludeSlotsInsideBlocks) {
              roomsMap[date] = [
                ...roomsMap[date],
                ...blocksByRoom[room][i].availableSlots
              ];
            }
          }
        }
        roomsMap[date] = this.groupSlotsByRoom(roomsMap[date]);
      }
      return roomsMap;
    },
    getFilterEvents(map) {
      // Calc empty rooms
      let availableRooms = this.getEmptyRooms(map);

      // Calc hols between blocks (with minimum 2 hr)
      let roomsMap = this.calcAvailableHoursBetweenBlocks(map);

      let finalTime = {};
      for (const key in roomsMap) {
        // add empty rooms
        const numDay = this.$moment(key).weekday();
        if (availableRooms[key] && availableRooms[key].length && numDay != 6) {
          const startHour = this.$moment(key + "T07:00", "YYYY-MM-DDTHH:mm");
          let endHour;
          if (numDay == 5) {
            endHour = this.$moment(key + "T15:00", "YYYY-MM-DDTHH:mm");
          } else {
            endHour = this.$moment(key + "T23:00", "YYYY-MM-DDTHH:mm");
          }
          availableRooms[key].forEach(room => {
            roomsMap[key].push({
              room: room,
              room_name: this.validRooms[room],
              start: startHour,
              end: endHour
            });
          });
        }
        // remove empty dates
        if (roomsMap[key].length) finalTime[key] = roomsMap[key];
      }
      return this.sortByRooms(finalTime);
    },
    sortByRooms(unsortedObject) {
      for (const key in unsortedObject) {
        unsortedObject[key] = unsortedObject[key].sort((a, b) => {
          const numberA = parseInt(a.room.charAt(a.room.length - 1));
          const numberB = parseInt(b.room.charAt(b.room.length - 1));
          return numberA - numberB;
        });
      }
      return unsortedObject;
    },
    includeSlotsInsideBlocks(dateToCheck) {
      const date = this.$moment(dateToCheck, "YYYY-MM-DD");
      const today = this.$moment();
      const sevenDaysFromNow = this.$moment().add(
        this.daysNumberForSurgSlot,
        "days"
      );
      return date.isSameOrAfter(today) && date.isSameOrBefore(sevenDaysFromNow);
    },
    surgBlockRequest() {
      this.$refs.addNewBlock.reset();
      this.isRequestBlock = true;
      this.selected_room = this.requestRoom;
      this.custom_start_time = null;
      this.start_time_static = null;
      this.custom_end_time = null;
      this.end_time_static = null;
      setTimeout(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          left: 0,
          behavior: "smooth"
        });
      }, 200);
    },
    isShowDate(rooms) {
      if (!this.showStandby) {
        const filtred = rooms.filter(r => !r.isIncludeSlotsInsideBlocks);
        return filtred.length;
      }
      return rooms.length;
    }
  },
  components: {
    VueCal,
    CloseSvg,
    ArrowBackSvg,
    Cleave
    // VueTimepicker
  }
};
</script>
